import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";

const ServiceSP = {}
ServiceSP.getDataAll = function (token) {

    return fetch({
        url: '/ref/satuanpendidikan',
        method: 'get',
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

ServiceSP.getDataByIDKota = function (token,id) {
    return fetch({
        url: '/ref/satuanpendidikan',
        method: 'get',
        params: {
            "id_kota":id
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

export default ServiceSP;
